<template>
  <div class="userMenu">

    <template v-if="showUser">
      <UserInfo></UserInfo>
      <div class="userMenu__accountInfo">
        <div class="userMenu__accountInfoRow">
          <span>Клуб</span>
          <strong>{{ isAtClub ? 'Участник клуба' : 'Не состоит в клубе' }}</strong>
        </div>
        <div class="userMenu__roles">
          <span>Роли</span>
          <ul v-if="userRoles.length">
            <li v-for="role in userRoles" :key="role">{{ role }}</li>
          </ul>
          <strong v-else>Не назначены</strong>
        </div>
      </div>
    </template>
    <template v-if="!showUser">
      <ActionButton @click="signInHandler">
        <template #caption>Войти</template>
      </ActionButton>
      <ActionButton @click="singUpHandler">
        <template #caption>Зарегистрироваться</template>
      </ActionButton>
    </template>
    <template v-else>
      <ActionButton @click="logoutHandler">
        <template #caption>Выйти из аккаунта</template>
      </ActionButton>
    </template>
  </div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";
import UserInfo from "@/components/UserMenu/UserInfo.vue";
import {useRouter} from "vue-router";
import {useAuthStore} from "@/store/auth";
import {computed} from "vue";
import {useSettingsStore} from "@/store/settings";

export default {
  name: "UserMenu",
  components: {UserInfo, ActionButton},
  props: ['userData'],
  emits: ['closeMenu'],
  setup(props, { emit }) {
    const authStore = useAuthStore();
    const settings = useSettingsStore()
    const router = useRouter();
    const showUser = computed(() => {
      return authStore.userId;
    })
    const isAtClub = computed(() => !!settings.user.is_at_club);
    const userRoles = computed(() => settings.userRoles || []);
    function singUpHandler() {
      router.push({name: 'SignUpStep1View'});
      emit('closeMenu');
    }

    function signInHandler() {
      emit('closeMenu');
      router.push({name: 'SignInView'});
    }
    function logoutHandler() {
      emit('closeMenu');
      authStore.doLogout();
      router.push({ name: "HomePage" });
    }

    return {
      logoutHandler,
      showUser,
      isAtClub,
      userRoles,
      signInHandler,
      singUpHandler,
      settings
    }
  }
}
</script>


<style scoped lang="scss">
.userMenu {
  font-family: var(--cd-default-font);
  width: 362px;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0px 4px 8px 0px #1C1C1D47;
  background: var(--cd-card-bg);
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__accountInfo {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
    border-top: 1px solid var(--cd-spoiler-border-color);
    border-bottom: 1px solid var(--cd-spoiler-border-color);
  }

  &__accountInfoRow,
  &__roles {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    text-align: left;
    color: var(--cd-text-minor);
    font-size: 14px;
    font-weight: 400;
  }

  &__roles ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4px 8px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  strong {
    display: flex;
    justify-content: flex-end;
    color: var(--cd-text);
    font-weight: 400;
  }
}

</style>
